import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import GoogleAddressAutocomplete from '../Google/GoogleAddressAutocomplete'; // Updated import
import styles from './LocationInputGroup.module.css';

const LocationInputGroup = ({ 
    label = "Location", 
    value, 
    onLocationSelect, 
    error, 
    suburb, 
    state, 
    disabled = false,
    placeholder = "Enter full address..."
}) => {
    return (
        <div className={styles.container}>
            {label && <label className={styles.label}>{label}</label>}
            
            <div className={error ? styles.autocompleteError : ''}>
                <GoogleAddressAutocomplete 
                    value={value || ''} 
                    onSelect={(data) => {
                        if (data) {
                            onLocationSelect(data);
                        } else {
                            // Cleared explicitly
                            onLocationSelect({ fullAddress: '', postcode: '', suburb: '', state: '' });
                        }
                    }}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={(val) => {
                        // Handle manual typing/deletion
                        if (val === '') {
                             onLocationSelect({ fullAddress: '', postcode: '', suburb: '', state: '' });
                        }
                    }}
                />
            </div>

            {/* Error Message */}
            {error && (
                <div className={styles.feedbackError}>
                    <AlertCircle size={12} /> {error}
                </div>
            )}

            {/* Success/State Feedback */}
            {!error && state && (
                <div className={styles.feedbackSuccess}>
                    <CheckCircle size={12} /> 
                    <span>
                        {suburb ? `${suburb}, ` : ''}{state} detected
                    </span>
                </div>
            )}
        </div>
    );
};

export default LocationInputGroup;